import React from 'react';
import moment from 'moment';
import { DateRangeInput } from 'components/forms/inputs';
import __ from 'utils/i18n';
import './MovementsFilters.scss';

export const MovementsFilters = ({ onFilter, initialStartDate, initialEndDate, children }) => {
  const setDateRange = ({ startDate, endDate }) => {
    onFilter({
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    });
  };

  const dateRangeInputValue = {
    startDate: initialStartDate || moment().subtract(7, 'days').format('YYYY-MM-DD'),
    endDate: initialEndDate || moment().format('YYYY-MM-DD'),
  };

  return (
    <div className="w-100">
      <div className="d-flex justify-content-between flex-wrap mb-1">
        <div>
          <p className="filters-title">
            {__('dashboard.components.filterForm.title')}
          </p>
        </div>
        <div className="d-flex">{children}</div>
      </div>
      <div className="d-flex flex-wrap flex-row align-items-center mb-2">
        <DateRangeInput
          past
          value={dateRangeInputValue}
          onInit={(value) => setDateRange(value)}
          onChange={setDateRange}
        />
      </div>
    </div>
  );
};

export default MovementsFilters;

